<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/auqNod/CoverDesign.jpg?1684514448945" alt="This image is the cover for the book Amy Lane's Greatest Hits - Amy's Alternative Universe, Dreamspinner Press Bundles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Amy Lane's Greatest Hits - Amy's Alternative Universe, Dreamspinner Press Bundles
      </h1>
      <p class="bookDescription body article font2">
        <p>From steampunk to fantasy, don't miss these four favorites of alternative-universe gay romance from Amy Lane in this exclusive bundle!</p> <p><em>Immortal</em>: As Teyth grows in the craft of metalwork, he also comes to love Diarmuid, the gentle, clever young man who introduces him to smithing. Together, can they keep their village safe and sustain the love that will make them immortal? —<em>Under the Rushes</em>: While Dorjan fights to save the world, Taern joins the battle simply to save Dorjan, knowing everything hinges on the heart of a man in armor and the strength of the man who loves him. —<em>Truth in the Dark</em>: Knife's entire existence has been as twisted as his flesh and his face. He's offered a way out: keep company with Aerie-Smith, cursed to walk upright in the form of a beast, on his island for the span of a year... and perform one "regrettable task" at year's end. —<em>Hammer &amp; Air</em>: Graeme ("Hammer") and Eirn have no words for what they are to each other. They negotiate the dangers of magic and motion, of sex, obsession, and tenderness, hoping to learn the word that can make sense of it all—one word they must earn for themselves.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amy Lane
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?46f12b50